import React, { useEffect, useState } from 'react';
import { Grid, InputSearch, Section } from '../../shared';
import { Button } from '../../shared/button/button';
import { EditClient } from '../add-client/edit-client';
import { NoGridData } from '../../../components/shared/grid-no-data/no-grid-data';
import './client-dashboard.scss';
export var ClientDashboard = function (_a) {
    var clientList = _a.clientList, pageSize = _a.pageSize, formTitles = _a.formTitles, pageFunction = _a.pageFunction, sortFunction = _a.sortFunction, handleKey = _a.handleKey, getRowId = _a.getRowId, fetchClients = _a.fetchClients, noOfExistingClients = _a.noOfExistingClients, refreshClientDetails = _a.refreshClientDetails, handleClickEdit = _a.handleClickEdit, handleCloseEdit = _a.handleCloseEdit;
    var _b = useState(false), showAddClient = _b[0], toggleShowAddClient = _b[1];
    var _c = useState(1), pageCount = _c[0], setPageCount = _c[1];
    var _d = useState(false), modalVisible = _d[0], setModalVisible = _d[1];
    var _e = useState(), clientData = _e[0], setClientData = _e[1];
    var _f = useState(false), isReset = _f[0], setReset = _f[1];
    var columns = [
        {
            id: 'id',
            description: 'Id',
            hidden: true,
        },
        {
            id: 'title',
            description: 'Title',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'name',
            description: 'Full name',
            extendClass: 'c-desktop-hide',
            render: function (column, row) {
                var _a, _b;
                return React.createElement(React.Fragment, null, "".concat((_a = row === null || row === void 0 ? void 0 : row.firstName) !== null && _a !== void 0 ? _a : '', " ").concat((_b = row === null || row === void 0 ? void 0 : row.surname) !== null && _b !== void 0 ? _b : ''));
            },
        },
        {
            id: 'firstName',
            description: 'First name',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'surname',
            description: 'Last name',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'dateOfBirth',
            description: 'Date of birth',
            extendClass: 'c-mobile-hide',
            render: function (column, row) {
                var _a;
                var date = new Date(Date.parse((_a = row[column.id]) !== null && _a !== void 0 ? _a : Date.now));
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", null, date.toLocaleDateString())));
            },
        },
        {
            id: 'email',
            description: 'Email',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'mobileNumber',
            description: 'Telephone',
            extendClass: 'c-mobile-hide',
        },
        {
            id: 'edit',
            description: '',
            render: function (column, row) {
                return (React.createElement(React.Fragment, null, React.createElement(Button, { variant: "secondary", type: "button", onClick: function (e) {
                        showModalEdit(row);
                        handleClickEdit(e);
                    } }, "Edit")));
            },
        },
    ];
    var showModalEdit = function (client) {
        setReset(true);
        setClientData(client);
        setModalVisible(true);
    };
    var showModalAdd = function () {
        setReset(true);
        setClientData(null);
        setModalVisible(true);
    };
    var hideModal = function () {
        setClientData(null);
        setModalVisible(false);
        handleCloseEdit();
    };
    useEffect(function () {
        var _a;
        var count = 1;
        if (clientList && clientList.length > 0)
            count = ((_a = clientList[0]) === null || _a === void 0 ? void 0 : _a.pageCount) || 1;
        setPageCount(count);
    }, [clientList]);
    return (React.createElement(React.Fragment, null,
        modalVisible && (React.createElement(EditClient, { show: modalVisible, handleClose: hideModal, client: clientData, titles: formTitles, fetchCustomers: fetchClients, setToggle: setModalVisible, resetForm: setReset, isReset: isReset, refreshClientDetails: refreshClientDetails })),
        React.createElement(Section, { className: "c-client", headerChildren: React.createElement("div", { className: "c-search-add" },
                !showAddClient && React.createElement(InputSearch, { id: "search-clients", onKeyUp: handleKey }),
                React.createElement("div", null,
                    React.createElement(Button, { type: "button", variant: "secondary", icon: "plus", iconPosition: "left", onClick: showModalAdd }, "New Client"))) },
            React.createElement(Grid, { rowData: clientList, extendClass: "c-client-dashboard__grid", columns: columns, pageSize: pageSize, selectRow: function (row) { return getRowId(row.id); }, maxPage: pageCount, gotoPage: pageFunction, sortRows: sortFunction, noRowsMessage: React.createElement(NoGridData, { image: "no-clients", message: noOfExistingClients === 0 ? 'You currently have no clients' : 'No matching records found' }), showHeaders: clientList && clientList.length > 0, disablePaging: false, defaultSortColumn: "id", defaultDirection: "Desc" }))));
};
